import { defineStore } from "pinia";

export const useCatalogPublicationInfluencesStore = defineStore("CatalogPublicationInfluencesStore", {
  state: () => ({
    data: null,
    loading: false,
  }),
  actions: {
    async fetchCatalogPublicationInfluences() {
      if (localStorage.getItem('store_influences')) {
        const data = JSON.parse(localStorage.getItem('store_influences'));
        this.data = data;
      } else {
        this.loading = true;
        try {
          const response = await this.$axios.get('/api/v1/catalog/influences.json');
          localStorage.setItem('store_influences', JSON.stringify(response.data));
          this.data = response.data;
        } catch (error) {
          console.error('Error fetching data:', error);
        }
        this.loading = false;
      }
    }
  }
});
